'use client';

import { Moon, Sun } from '@phosphor-icons/react/dist/ssr';
import { useTheme } from 'next-themes';

import { Button } from '@skrym/shared/ui/button';

export function DarkModeToggle() {
  const { setTheme, resolvedTheme } = useTheme();

  return (
    <Button
      variant="outline"
      icon
      onClick={(_e) => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')}
    >
      <Sun weight="bold" className="hidden dark:block" />
      <Moon weight="bold" className="block dark:hidden" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
